module.exports = __webpack_public_path__ + "assets/stand21.19ec158aed66537f5c9f36ea0eb9d4e7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/stand21.png
 ** module id = 194
 ** module chunks = 0
 **/